import { render, staticRenderFns } from "./TooltipBtnPinned.vue?vue&type=template&id=430cf6d0&"
import script from "./TooltipBtnPinned.vue?vue&type=script&lang=ts&"
export * from "./TooltipBtnPinned.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipBtnPinned.vue?vue&type=style&index=0&id=430cf6d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports